module.exports = __webpack_public_path__ + "static/media/savsprite172.f923f923.gif";